import { render, staticRenderFns } from "./GenericAddressItem.vue?vue&type=template&id=a2d27e88&"
import script from "./GenericAddressItem.vue?vue&type=script&lang=js&"
export * from "./GenericAddressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports